import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-pre-implantation-genetic-testing',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './pre-implantation-genetic-testing.component.html',
  styleUrl: './pre-implantation-genetic-testing.component.scss'
})
export class PreImplantationGeneticTestingComponent implements OnInit {

  constructor(private route: Router, private metaService: Meta,
    private titleService: Title, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {

    const homeSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "NCare IVF Kannur, Kerala",
      "image": "https://ncareivfkannur.com/assets/images/header/logo.svg",
      "@id": "https://ncareivfkannur.com/",
      "url": "https://ncareivfkannur.com/pre-implantation-genetic-testing",
      "telephone": "8606443030",
      "priceRange": "₹",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Balram Memorial Buidling, N.E, Rajiv Gandhi Rd",
        "addressLocality": "Kannur, Kerala",
        "postalCode": "670001",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 11.8710259,
        "longitude": 75.3641411
      },
      "sameAs": [
        "https://www.facebook.com/people/Ncare-IVF-Kannur/61574105283962/",
        "https://www.instagram.com/ncareivfkannur/",
        "https://www.youtube.com/@NCAREIVFKANNUR/"
      ]
    }

    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(homeSchema);
    this.renderer.appendChild(this.document.head, script);

    this.titleService.setTitle('Preimplantation Genetic Testing (PGT) in Kannur | Ncare IVF Centre');
    this.metaService.updateTag({
      name: 'description',
      content: 'Ensure a healthy pregnancy with Preimplantation Genetic Testing (PGT) at Ncare IVF Center in Kannur. Screen embryos for genetic conditions with advanced fertility technology and expert care.'
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: 'pgt treatment, Preimplantation Genetic Testing, pgt fertility treatment, pgt fertility treatment in Kannur, pgt treatment in kannur'
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'Preimplantation Genetic Testing (PGT) in Kannur | Ncare IVF Centre'
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: 'Ensure a healthy pregnancy with Preimplantation Genetic Testing (PGT) at Ncare IVF Center in Kannur. Screen embryos for genetic conditions with advanced fertility technology and expert care.'
    });
  }

  contactus() {
    this.route.navigate(['/contact-us']);
  }


}
